export function deferSingleton(func: (...args: any[]) => void | Promise<void>, interval = 0) {
	let timeout: number | undefined = undefined

	return function (this: any, ...args: any[]) {
		if (timeout !== undefined) {
			globalThis.clearTimeout(timeout)
		}

		timeout = globalThis.setTimeout(async () => {
			try {
				const result = func.apply(this, args)
				if (result instanceof Promise) await result
			} finally {
				timeout = undefined
			}
		}, interval) as unknown as number
	}
}

export function deferredSingleton(interval = 0) {
	return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
		descriptor.value = deferSingleton(descriptor.value, interval)
	}
}
